
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { LeverantorCommandBase } from "./LeverantorCommandBase";

export class DisconnectVirkesleverantorCommand extends LeverantorCommandBase {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DisconnectVirkesleverantorCommand";

    constructor(leverantorGuid: string, avtalGuid: string) {
        super(avtalGuid, leverantorGuid, DisconnectVirkesleverantorCommand.$type, CommandType.Delete);
    }
}
